const DonationOrderByOptions = {
    Date: 1,
    DueDate: 2,
    Value: 3,
    Name: 4,
    Status: 5,
    Type: 6
};

export default DonationOrderByOptions;
